import { Component } from '@angular/core';

@Component({
    selector: 'app-california-regulation-report',
    imports: [],
    templateUrl: './california-regulation-report.component.html',
    styleUrl: './california-regulation-report.component.scss'
})
export class CaliforniaRegulationReportComponent {

}
